import { apiRoots } from 'common/services/api/apiConstants';
import commonApiService from 'common/services/api/commonApiService';
import { CalibrationData } from '../../store/CalibrationTable/types';

const getSearchQueryMap = () => {
    const query = window.location.search.substring(1);
    const searchQueryMap = new URLSearchParams(query);
    return searchQueryMap;
};

export const calibrationDataServices = {
    fetchCalibrationData: async (searchText?: string, assessmentRunId?: string) => {
        let tableData;
        let error;
        const searchQuery = getSearchQueryMap();
        const contentItemId = searchQuery.get('contentItemIds');
        let searchJSON;
        if (assessmentRunId) {
            searchJSON = {
                searchText: searchText || '',
                filters: {
                    progress: '$all',
                    assessmentRunStatus: '$all',
                    contentSections: '$exists',
                    isCalibrationTest: true,
                    assessmentRunId,
                    $nested: [
                        {
                            '$path': 'contentSections',
                            'contentSections.contentItemId': contentItemId,
                            'contentSections.publishStatus': ['sfx', 'sfx2'],
                        },
                    ],
                },
            };
        } else {
            searchJSON = {
                searchText: searchText || '',
                filters: {
                    'unCalibratedContentSections': '$exists',
                    'unCalibratedContentSections.contentItemId': contentItemId,
                    'unCalibratedContentSections.publishStatus': ['sfx', 'sfx2'],
                },
                columns: [{ name: 'objectId', order: 'asc' }],
            };
        }

        const url = `${apiRoots.ASSESSMENT}GetAtcCalibrationContentBlockAssociatedTestEvents?`
                        + `searchJSON=${encodeURIComponent(JSON.stringify(searchJSON))}`
                        + `&contentItemId=${contentItemId}`;
        try {
            tableData = await commonApiService.getCalibrationData(url) as CalibrationData;
        } catch (err) {
            error = err;
        }
        return { tableData, error };
    },
    checkUserAccessRole: async (assessmentRunId: number) => {
        const url = `${apiRoots.ASSESSMENT}AssessmentRunUserPermission?assessmentRunId=${assessmentRunId}`;
        let response;
        let error;
        try {
            response = await commonApiService.checkUserCustomRoleSFX(url);
        } catch (err) {
            error = err;
        }

        return {
            response,
            error,
        };
    },
};
